import clsx from 'clsx';
import { StudentFeedbackIssue, StudentFeedbackIssueLabelMap } from '@airreading/common/data';
import { Badge } from '@/components/ui/badge';

interface StudentFeedbackIssueBadgeProps {
  studentFeedbackIssue: StudentFeedbackIssue;
}

const StudentFeedbackIssueColorMap: Record<StudentFeedbackIssue, string> = {
  [StudentFeedbackIssue.attendance_issue]: 'bg-[#FEF3C7] hover:bg-[#FEF3C7] text-[#EA580C]',
  [StudentFeedbackIssue.behavior_issue]: 'bg-[#ECFCCB] hover:bg-[#ECFCCB] text-[#65A30D]',
  [StudentFeedbackIssue.learning_issue]: 'bg-[#FFE4E6] hover:bg-[#FFE4E6] text-[#EA580C]',
  [StudentFeedbackIssue.tech_issue]: 'bg-[#DBEAFE] hover:bg-[#DBEAFE] text-[#2563EB]',
};

export const StudentFeedbackIssueBadge = ({ studentFeedbackIssue }: StudentFeedbackIssueBadgeProps) => {
  return (
    <Badge
      className={clsx('p-1 rounded-[6px] text-[14px] text-center', StudentFeedbackIssueColorMap[studentFeedbackIssue])}
    >
      {StudentFeedbackIssueLabelMap[studentFeedbackIssue]}
    </Badge>
  );
};
